(function () {
  const THRESHOLD = 100000;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderBanner(totalPrice) {
    const banner = document.getElementById('cart-contest-banner');
    if (!banner) return;

    const parent = banner.parentElement;
    if (parent) {
      parent.style.overflow = 'visible';
      parent.style.height = 'auto';
    }

    const remaining = THRESHOLD - totalPrice;
    const progress = Math.min((totalPrice / THRESHOLD) * 100, 100);
    const qualified = totalPrice >= THRESHOLD;

    const flagSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="28" height="18" style="border-radius:2px;flex-shrink:0">
      <rect width="60" height="30" fill="#B22234"/>
      <rect y="2.3" width="60" height="2.3" fill="#fff"/>
      <rect y="6.9" width="60" height="2.3" fill="#fff"/>
      <rect y="11.5" width="60" height="2.3" fill="#fff"/>
      <rect y="16.2" width="60" height="2.3" fill="#fff"/>
      <rect y="20.8" width="60" height="2.3" fill="#fff"/>
      <rect y="25.4" width="60" height="2.3" fill="#fff"/>
      <rect width="24" height="16.2" fill="#3C3B6E"/>
    </svg>`;

    if (qualified) {
      banner.innerHTML = `
        <div class="ccb ccb--qualified">
          <div class="ccb__icon">${flagSVG}</div>
          <div class="ccb__content">
            <p class="ccb__title">You've been entered</p>
            <p class="ccb__sub">Your order qualifies — you're now in the running to win our <strong>10K gold American flag ring</strong>. Winner selected July 4th, America's 250th birthday.</p>
          </div>
        </div>
      `;
    } else {
      banner.innerHTML = `
        <div class="ccb ccb--progress">
          <p class="ccb__label">
            <span class="ccb__flag" style="display:inline-flex;vertical-align:middle;margin-right:6px">${flagSVG}</span>
            You're <strong>${formatMoney(remaining)} away</strong> from entering to win a <strong>10K gold American flag ring</strong>
          </p>
          <div class="ccb__bar-track">
            <div class="ccb__bar-fill" style="width: ${progress}%"></div>
          </div>
        </div>
      `;
    }
  }

  function fetchAndRender() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderBanner(cart.total_price);
      })
      .catch(function (err) {
        console.error('[cart-contest-banner] fetch error:', err);
      });
  }

function watchSubtotal() {
    const cartBody = document.querySelector('.AOV-CartDrawer-Body');
    if (!cartBody) return;

    let debounceTimer = null;

    const subtotalObserver = new MutationObserver(function (mutations) {
      const relevant = mutations.some(function (m) {
        // Ignore our own banner mutations
        if (m.target.id === 'cart-contest-banner') return false;
        if (m.target.closest && m.target.closest('#cart-contest-banner')) return false;

        // ✅ Exactly what AOV mutates on quantity change / remove
        if (
          m.target.classList.contains('AOV-CartDrawer-Item') ||
          m.target.classList.contains('AOV-CartDrawer-ItemHeader') ||
          (m.target.className && typeof m.target.className === 'string' &&
            m.target.className.includes('AOV-CartDrawer-Variant'))
        ) return true;

        return false;
      });

      if (relevant) {
        // Debounce — AOV fires multiple mutations per update
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(fetchAndRender, 400);
      }
    });

    subtotalObserver.observe(cartBody, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }

  function setupDrawerObserver() {
    // Watch for drawer opening + DOM injection
    const drawerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        // Drawer opened
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (
            target.classList.contains('AOV-CartDrawer--open') ||
            target.classList.contains('AOV-CartDrawer-Overlay')
          ) {
            fetchAndRender();
            watchSubtotal();
          }
        }
        // New nodes injected (AOV re-render)
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (
                node.id === 'cart-contest-banner' ||
                (node.querySelector && node.querySelector('#cart-contest-banner'))
              ) {
                fetchAndRender();
              }
              // AOV re-rendered the cart body
              if (
                node.classList && (
                  node.classList.contains('AOV-CartDrawer-Body') ||
                  node.classList.contains('AOV-CartDrawer__CustomHTMLBody')
                )
              ) {
                fetchAndRender();
                watchSubtotal();
              }
            }
          });
        }
      });
    });

    drawerObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  // Standard cart events (fallback)
  document.addEventListener('cart:updated', fetchAndRender);
  document.addEventListener('cart-update', fetchAndRender);
  document.addEventListener('theme:cart:update', fetchAndRender);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupDrawerObserver();
      watchSubtotal();
      fetchAndRender();
    });
  } else {
    setupDrawerObserver();
    watchSubtotal();
    fetchAndRender();
  }

})();